import {
  GET_PRODUCT_REQUEST,
  GET_PRODUCT_BY_SKU_REQUEST,
  LIST_PRODUCTS_REQUEST,
  PRODUCT_CLICK_SUCCESS_GTM
} from './constants';

export const listProducts = (slug, qString, page, viewType) => ({
  type: LIST_PRODUCTS_REQUEST,
  slug,
  qString,
  page,
  viewType
});

export const getProduct = (slug) => ({ type: GET_PRODUCT_REQUEST, slug });

export const getProductBySku = (sku) => ({
  type: GET_PRODUCT_BY_SKU_REQUEST,
  sku
});

export const productClick = (product) => ({
  type: PRODUCT_CLICK_SUCCESS_GTM,
  payload: { product }
});
